module.exports = __webpack_public_path__ + "static/media/icon-dropdown-arrow.5168e48f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-dropdown-arrow.svg
// module id = 1849
// module chunks = 0